import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { ProductsPreview } from '../components/home/ProductsPreview';
import { MarketsSection } from '../components/home/MarketsSection';
import { WhyNaviton } from '../components/home/WhyNaviton';
import { CTASection } from '../components/home/CTASection';
import { SEO, OrganisationSchema } from '../components/SEO';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEO
        path="/"
        description="Naviton Global Pty Ltd — Your strategic partner for international trade, premium sourcing, and seamless logistics coordination across global markets. Based in Sydney, Australia."
      />
      <OrganisationSchema />
      <Header />
      <main>
        <HeroSection />
        <ServicesOverview />
        <ProductsPreview />
        <MarketsSection />
        <WhyNaviton />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
